import React, { useEffect } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  SafeAreaView,
  Dimensions,
  FlatList,
  NativeEventEmitter,
  NativeModules,
  BackHandler,
  Linking,
  ScrollView,
  Platform,
} from "react-native";

const WalletSuccess = ({ navigation }) => {
  useEffect(() => {
    var query = window.location.search.substring(1);
    const params = new URLSearchParams(query);
    const order_id = params.get("order_id");

    setTimeout(() => {
      //navigation.pop();
      // const opener =
      //   window?.opener?.postMessage || window?.parent?.opener?.postMessage;
      // var href = window.location.origin;
      // console.log(opener);
      // opener(
      //   { isJusPaySuccess: "failed", amount: 1000 },
      //   href + "/wallet/funds?dep=false"
      // );
      navigation.pop();
    }, 500);

    //fetchJuspayStatus(order_id);
  }, []);
  return (
    <View>
      <Text>Success</Text>
    </View>
  );
};

export default WalletSuccess;
